import type { ReactNode } from 'react';
import { clinicDay, clinicTimes, placesLabel, type ClinicFacts } from '../api/clinics.js';
import { NoteRead } from './note-read.js';

/**
 * What every clinic screen opens with: the picture when there is one, the
 * title, when and where, the places, and the description (boards 2 and 3).
 */
export function ClinicHead({ clinic, back }: { clinic: ClinicFacts; back?: ReactNode }) {
  const full = clinic.places_free <= 0;
  return (
    <>
      {clinic.image_url ? <img className="clinic-image" src={clinic.image_url} alt="" /> : null}
      <div className="page-head clinic-head">
        {back}
        <div className="clinic-head-text">
          <h2>{clinic.title}</h2>
          <span className="detail">
            {clinicDay(clinic.slot_start)}, {clinicTimes(clinic.slot_start, clinic.slot_end)}
          </span>
          <span className="detail">
            Coach {clinic.coach_name} · {clinic.facility_name}
          </span>
        </div>
        <span className={full ? 'places clinic-full' : 'places'}>{placesLabel(clinic.places_free)}</span>
      </div>
      {clinic.description ? (
        <div className="clinic-description">
          <NoteRead html={clinic.description} />
        </div>
      ) : null}
    </>
  );
}
